<template>
  <v-container fluid v-if="items">
    <v-row dense row>
      <v-col>
        <v-select
          v-model="selected"
          :items="items"
          label="Content type"
          item-text="title"
          item-value="id"
        ></v-select>
      </v-col>
    </v-row>
    <v-row dense row>
      <v-col>
        <div class="hyp-grd-home-data-container" v-html="body"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashFind from "lodash/find";

import { getGRDProfile } from "@/services/grd/grd.service";

export default {
  name: "GrdHomeGlobalRiskData",
  data: () => ({
    items: [],
    selected: null,
  }),
  async mounted() {
    const items = await getGRDProfile();
    this.items =
      items && Array.isArray(items) && items.length > 0 ? items : null;

    this.selected = this.items?.length > 0 ? this.items[0].id : null;
  },
  computed: {
    body() {
      if (this.selected && this.items?.length > 0) {
        const item = lodashFind(this.items, ["id", this.selected]);
        if (item?.body) {
          return item.body;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
.hyp-grd-home-data-container {
  height: 84vh;
  overflow-y: auto;
}
</style>
